/**
 * Full transaction history rows for the Transactions page (FlowPay-style table).
 * @typedef {'in' | 'out'} TxDirection
 * @typedef {'ACH' | 'WIRE' | 'CRYPTO'} TxRail
 * @typedef {'completed' | 'pending' | 'cancelled' | 'inprogress'} TxStatusVariant
 */

export const workspaceTransactionHistory = [
  {
    id: "h1",
    direction: "in",
    rail: "ACH",
    from: "Acme Corp · Chase •••• 3210",
    to: "0x742d…3f8B",
    usd: "$4,200.00",
    crypto: "0.0612 ETH",
    cryptoSettled: true,
    status: "Completed",
    statusVariant: "completed",
    date: "Mar 26, 2026",
  },
  {
    id: "h2",
    direction: "in",
    rail: "WIRE",
    from: "Northwind LLC · JPM •••• 9012",
    to: "0x3b91…e8a1",
    usd: "$12,800.00",
    crypto: "0.1860 ETH",
    cryptoSettled: true,
    status: "Completed",
    statusVariant: "completed",
    date: "Mar 25, 2026",
  },
  {
    id: "h3",
    direction: "out",
    rail: "CRYPTO",
    from: "Polygon custodial (USDC)",
    to: "0x9d44…2f00",
    usd: "−750 USDC",
    crypto: "750 USDC",
    cryptoSettled: true,
    status: "Completed",
    statusVariant: "completed",
    date: "Mar 24, 2026",
  },
  {
    id: "h4",
    direction: "out",
    rail: "CRYPTO",
    from: "USDC balance",
    to: "0x1c88…7bba",
    usd: "−500 USDC",
    crypto: "+820 POL",
    cryptoSettled: true,
    status: "Completed",
    statusVariant: "completed",
    date: "Mar 23, 2026",
  },
  {
    id: "h5",
    direction: "in",
    rail: "ACH",
    from: "Wells Fargo •••• 8891",
    to: "Pending settlement",
    usd: "$1,000.00",
    crypto: "—",
    cryptoSettled: false,
    status: "Pending",
    statusVariant: "pending",
    date: "Mar 23, 2026",
  },
  {
    id: "h6",
    direction: "out",
    rail: "ACH",
    from: "USDC balance",
    to: "Bank of America •••• 1044",
    usd: "−$1,200.00",
    crypto: "1,200 USDC",
    cryptoSettled: true,
    status: "In progress",
    statusVariant: "inprogress",
    date: "Mar 22, 2026",
  },
  {
    id: "h7",
    direction: "in",
    rail: "ACH",
    from: "Bank of America •••• 1044",
    to: "0x7a2f…9c4e",
    usd: "$450.00",
    crypto: "≈ 450.12 USDC",
    cryptoSettled: true,
    status: "Completed",
    statusVariant: "completed",
    date: "Mar 20, 2026",
  },
  {
    id: "h8",
    direction: "in",
    rail: "ACH",
    from: "NFCU •••• 7720",
    to: "Queued → Polygon",
    usd: "$200.00",
    crypto: "—",
    cryptoSettled: false,
    status: "In progress",
    statusVariant: "inprogress",
    date: "Mar 18, 2026",
  },
  {
    id: "h9",
    direction: "in",
    rail: "ACH",
    from: "Chase •••• 3210",
    to: "—",
    usd: "$0.00",
    crypto: "—",
    cryptoSettled: false,
    status: "Cancelled",
    statusVariant: "cancelled",
    date: "Mar 21, 2026",
  },
];
